import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VTextField,_vm._g(_vm._b({attrs:{"value":_vm.displayValue,"prefix":`[${(_vm.weightUnit || '').toLowerCase()}]`,"type":"number","step":"any","error-messages":_vm.errors}},'v-text-field',_vm.$attrs,false),_vm.inputListeners))
}
var staticRenderFns = []

export { render, staticRenderFns }